export const PAGE_TITLE_FONT = 'page-titleFont';

export const PAGE_TITLE_COLOR = 'page-titleColor';
export const PAGE_TITLE_COLOR_PATH = `style.colors.${PAGE_TITLE_COLOR}`;

export const PAGE_LINK_FONT = 'page-linkFont';
export const PAGE_LINK_FONT_PATH = `style.colors.${PAGE_TITLE_COLOR}`;

export const PAGE_LINK_COLOR = 'page-linkColor';
export const PAGE_LINK_COLOR_PATH = `style.colors.${PAGE_TITLE_COLOR}`;

export const PAGE_BACKGROUND_COLOR = 'page-backgroundColor';
export const PAGE_BACKGROUND_COLOR_PATH = `style.colors.${PAGE_BACKGROUND_COLOR}`;

export const PAGE_BORDER_COLOR = 'page-borderColor';
export const PAGE_BORDER_COLOR_PATH = `style.colors.${PAGE_BORDER_COLOR}`;

export const PAGE_BORDER_WIDTH = 'page-borderWidth';
export const PAGE_BORDER_WIDTH_PATH = `style.numbers.${PAGE_BORDER_WIDTH}`;
